/**
 * 쿠키 유틸리티
 *
 * WeDriveFinder, useThirdPartyHeader 등에서 중복 정의되던 쿠키 접근 함수 통합.
 */

/** 이름으로 쿠키 값을 가져옴 */
export const getCookie = (name: string): string => {
  const match = decodeURIComponent(document.cookie)
    .split(';')
    .find((c) => c.trimStart().startsWith(name + '='));
  return match ? match.split('=').slice(1).join('=').trim() : '';
};

/** 쿠키 저장 (.wehago.com 도메인 기본) */
export const setCookie = (
  name: string,
  value: string,
  { domain = '.wehago.com', path = '/' }: { domain?: string; path?: string } = {},
): void => {
  document.cookie = `${name}=${encodeURIComponent(value)};domain=${domain};path=${path}`;
};
